import { createSlice } from '@reduxjs/toolkit';

const loadAuthFromStorage = () => {
  try {
    const stored = localStorage.getItem('hbfurniture_auth');
    if (!stored) return { user: null, isAuthenticated: false, role: null };
    const parsed = JSON.parse(stored);
    if (!parsed?.user || !parsed?.role || !parsed?.user?.token) return { user: null, isAuthenticated: false, role: null };
    return {
      user: parsed.user,
      isAuthenticated: true,
      role: parsed.role
    };
  } catch {
    return { user: null, isAuthenticated: false, role: null };
  }
};

const saveAuthToStorage = (state) => {
  try {
    if (!state.isAuthenticated || !state.user) {
      localStorage.removeItem('hbfurniture_auth');
      return;
    }
    localStorage.setItem('hbfurniture_auth', JSON.stringify({ user: state.user, role: state.role }));
  } catch {
    // no-op
  }
};

const authSlice = createSlice({
  name: 'auth',
  initialState: loadAuthFromStorage(),
  reducers: {
    login(state, action) {
      state.user = {
        ...(state.user || {}),
        ...(action.payload.user || {}),
      };
      state.isAuthenticated = true;
      state.role = action.payload.role;
      saveAuthToStorage(state);
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.role = null;
      saveAuthToStorage(state);
    }
  }
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
